import axios from "axios";


export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";

export function requestPassword(email) {
    return axios.post(REQUEST_PASSWORD_URL, { email });
}
